import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=187ff022&scoped=true&"
import script from "./tagList.vue?vue&type=script&lang=js&"
export * from "./tagList.vue?vue&type=script&lang=js&"
import style0 from "./tagList.vue?vue&type=style&index=0&id=187ff022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ff022",
  null
  
)

export default component.exports